import axios from 'axios';

import { types } from '../types/types';
import { msg as msgSwal } from './swal_msg';
import { request } from '../helpers/requestHelper';
import { isCaptchaError, normalizeEmail } from '../helpers/security';

const baseUrl = process.env.REACT_APP_NEFRO_API_URL;

const responseBody = error => error?.response?.data || { status: false, msg: 'network-error' };

const showFailure = (body, title) => {
    if (isCaptchaError(body)) return;
    if (body?.msg === 'rate-limit') {
        const seconds = Number(body.retry_after) || 60;
        msgSwal('warning', title, `Demasiados envíos. Intenta de nuevo en ${seconds} segundos.`);
    } else if (body?.msg === 'file-too-large')
        msgSwal('warning', title, 'Cada archivo debe pesar como máximo 5 MB.');
    else if (body?.msg === 'invalid-file')
        msgSwal('warning', title, 'El archivo seleccionado no es válido.');
    else
        msgSwal('warning', title, 'No se pudo enviar el formulario.');
};

const appendSecurity = (form, model, turnstileToken) => {
    form.append('website', model.website || '');
    if (turnstileToken) form.append('turnstile_token', turnstileToken);
};

export const form1Submit = (model, turnstileToken = '') => async dispatch => {
    dispatch(form1Backdrop(true));
    try {
        const form = new FormData();
        for (const field of ['name', 'lastname', 'tel', 'message_type', 'occurrence_site', 'branch', 'msg'])
            form.append(field, model[field] || '');
        form.append('email', normalizeEmail(model.email));
        appendSecurity(form, model, turnstileToken);
        (model.images || []).forEach(image => form.append('file', image));
        const { data } = await axios.post(`${baseUrl}/form/contact`, form);
        if (data.status) {
            msgSwal('success', 'Quejas y sugerencias', 'Formulario enviado');
            dispatch(form1Submitted(true));
        } else {
            dispatch(form1Backdrop(false));
            showFailure(data, 'Quejas y sugerencias');
        }
        return data;
    } catch (error) {
        const body = responseBody(error);
        dispatch(form1Backdrop(false));
        showFailure(body, 'Quejas y sugerencias');
        return body;
    }
};

export const sendFooterContact = (model, turnstileToken = '') => async dispatch => {
    dispatch(form1Backdrop(true));
    try {
        const resp = await request('form/footer-contact', {
            ...model,
            email: normalizeEmail(model.email),
            website: model.website || '',
            turnstile_token: turnstileToken
        }, 'POST');
        const body = await resp.json();
        if (body.status) {
            msgSwal('success', 'Mensaje enviado', 'Muchas gracias por sus comentarios');
            dispatch(form1Submitted(true));
        } else {
            dispatch(form1Backdrop(false));
            showFailure(body, 'Contacto');
        }
        return body;
    } catch (error) {
        dispatch(form1Backdrop(false));
        const body = { status: false, msg: 'network-error' };
        showFailure(body, 'Contacto');
        return body;
    }
};

export const form2Submit = (model, turnstileToken = '') => async dispatch => {
    dispatch(form2Backdrop(true));
    try {
        const form = new FormData();
        for (const field of ['name', 'lastname', 'tel']) form.append(field, model[field] || '');
        form.append('email', normalizeEmail(model.email));
        form.append('file', model.file);
        appendSecurity(form, model, turnstileToken);
        const { data } = await axios.post(`${baseUrl}/form/postulation`, form);
        if (data.status) {
            msgSwal('success', 'Postulación', 'Formulario enviado');
            dispatch(form2Submitted(true));
        } else {
            dispatch(form2Backdrop(false));
            showFailure(data, 'Postulación');
        }
        return data;
    } catch (error) {
        const body = responseBody(error);
        dispatch(form2Backdrop(false));
        showFailure(body, 'Postulación');
        return body;
    }
};

export const form3Submit = (model, turnstileToken = '') => async dispatch => {
    dispatch(form3Backdrop(true));
    try {
        const { data } = await axios.post(`${baseUrl}/form/distributor`, {
            ...model,
            email: normalizeEmail(model.email),
            website: model.website || '',
            turnstile_token: turnstileToken
        });
        if (data.status) {
            msgSwal('success', 'Distribuidor', 'Formulario enviado');
            dispatch(form3Submitted(true));
        } else {
            dispatch(form3Backdrop(false));
            showFailure(data, 'Distribuidor');
        }
        return data;
    } catch (error) {
        const body = responseBody(error);
        dispatch(form3Backdrop(false));
        showFailure(body, 'Distribuidor');
        return body;
    }
};

export const form1Backdrop = status => ({ type: types.form1Backdrop, payload: status });
export const form2Backdrop = status => ({ type: types.form2Backdrop, payload: status });
export const form3Backdrop = status => ({ type: types.form3Backdrop, payload: status });

export const myForms = () => async dispatch => {
    try {
        const resp = await request('form/list');
        const body = await resp.json();
        dispatch(formListLoaded(body.resp || []));
    } catch (error) {
        dispatch(formListLoaded([]));
        msgSwal('error', 'Formularios', 'No se puede cargar la lista de formularios');
    }
};

const formListLoaded = payload => ({ type: types.formListLoaded, payload });

export const formRegister = model => async dispatch => {
    try {
        const resp = await request('form/reg', model, 'POST');
        const body = await resp.json();
        if (body.status) {
            dispatch(formRegistered(body.resp));
            msgSwal('success', 'Formulario', 'Registrado con éxito');
        } else msgSwal('warning', 'Formulario no registrado', 'Inténtelo de nuevo, por favor');
    } catch (error) {
        msgSwal('error', 'Formulario', 'No se pudo registrar el formulario');
    }
};

export const formRegistered = payload => ({ type: types.formReg, payload });
export const formReset = () => ({ type: types.formReset });
export const form1Submitted = payload => ({ type: types.form1Submitted, payload });
export const form2Submitted = payload => ({ type: types.form2Submitted, payload });
export const form3Submitted = payload => ({ type: types.form3Submitted, payload });

// Alias conservado para consumidores históricos del formulario principal.
export const footerFormSubmit = form1Submit;
